/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 5/9/2022
 */

import BillingData, {BillingType} from "@shared/Billing/BillingData";
import BillingItem from "@shared/Billing/BillingItem";
import InvoiceItem from "@shared/Invoice/InvoiceItem";
import ShareableItem from "@shared/ShareableFilterableItem.js";

export default class InvoiceableDbObject extends ShareableItem {

	createInvoice(billFromCoachId, billToClientId, currencyItem){
		let billingItemPriceTitleArray = this.getInvoiceBillingData()
		let billingData = new BillingData()
		billingData.billingType = BillingType.FIXED
		for(let billingItemData of billingItemPriceTitleArray){
			billingData.billingItems.push(new BillingItem(billingItemData.price, billingItemData.title))
		}
		let invoiceItem = InvoiceItem.instanceWithFromTo(billingData, billFromCoachId, billToClientId, currencyItem)

		this.setTargetObjectInternal(invoiceItem)
		return invoiceItem
	}

	setTargetObjectInternal(invoiceItem){

		let objectId = this.id
		let objectType = this.getInvoiceObjectType()
		let objectTitle = this.getInvoiceObjectTitle()

		invoiceItem.setTargetObject(objectId, objectType, objectTitle)

	}

	getInvoiceBillingData(){
		throw Error("InvoiceableDbObject: getInvoiceData not implemented, ", this)
	}

	getInvoiceObjectType(){
		throw Error("InvoiceableDbObject: getInvoiceObjectType not implemented, ", this)
	}

	getInvoiceObjectTitle(){
		throw Error("InvoiceableDbObject: getInvoiceObjectTitle not implemented, ", this)
	}

}
